import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import get from 'lodash/get';
import { Button } from '../../Button';
import ProfilePic from '../../Header/profile-pic.svg';
import { ProjectViewConsumer } from '../../../containers/ProjectView/ProjectView.context';

const ProjectViewHeader = ({
  project: { deadline, status, manager },
  project,
}) => {
  const isPending = status === 'pending';
  return (
    <ProjectViewConsumer>
      {({ handleEditProject, isLoading }) => (
        <div className="row px-2 mt-11 bg-white shadow-mid">
          <div className="col-12">
            <div className="align-self-stretch">
              <div className="row">
                <div className="co-12 col-xl-7 py-4">
                  <p className="t-13 mb-0 text-gray-2 project-view-title">
                    Welcome to your project summary. This is where you’ll find
                    all the information you have submitted along with draft
                    projects as they are completed.
                  </p>
                </div>
                <div className="col-12 col-md-6 col-xl border-xl-left border-xl-right py-4 d-flex justify-content-center">
                  <div className="row">
                    <div className="col d-flex  justify-content-center align-items-center">
                      <div
                        className="nav-item-avatar-md"
                        style={{
                          backgroundImage: `url(${get(
                            manager,
                            'avatar_url',
                            ProfilePic,
                          )})`,
                        }}
                      />
                      <div className="details ml-2">
                        <p className="t-17 mb-0 text-capitalize text-gray-mate mb-0">
                          {get(manager, 'name', 'PENDING')}
                        </p>
                        <p className="t-12 mb-0 text-gray-2 font-weight-mid mb-1">
                          Account Manager
                        </p>
                        <p className="t-12 mb-0 text-uppercase text-dark-teal cursor-pointer  font-weight-mid">
                          <a href={`mailto:${get(manager, 'email')}`}>
                            {get(manager, 'email')}
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-xl py-4 d-flex">
                  <div className="row align-items-center align-self-stretch flex-fill">
                    {false && (
                      <div className="col">
                        <div className="w-100 text-center">
                          <p className="text-gray t-12 font-weight-medium mb-1">
                            DEADLINE
                          </p>
                          <span className="text-gray-2 t-19 font-weight-mid font-montserrat">
                            {moment(deadline, 'YYYY-MM-DD').format('MM/DD/YYYY')}
                          </span>
                        </div>
                      </div>
                    )}
                    {false && isPending && (
                      <div className="col text-center">
                        <Button
                          title="Edit Project"
                          disabled={isLoading}
                          onClick={() => handleEditProject(project)}
                          className="btn-outline-primary btn-md t-15"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </ProjectViewConsumer>
  );
};

ProjectViewHeader.propTypes = {
  project: PropTypes.shape({
    user: PropTypes.shape({
      type: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      avatar_url: PropTypes.string,
    }),
    project_name: PropTypes.string.isRequired,
    project_brief: PropTypes.string.isRequired,
    deadline: PropTypes.string.isRequired,
  }),
};

export default ProjectViewHeader;



// WEBPACK FOOTER //
// ./src/components/ProjectView/ProjectViewHeader/ProjectViewHeader.js